import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit,
        DownloadTemplate,Dropzone,SegmentComplete,ResolutionStep,
        ResolutionStack} from '../components/Common';
import {EditSizeLabel,EditSizeLink,EditableSelect,InputPhoto,
        EditableBox,Select,Button,Date,Box,Info,Area,List,
        TextButton,MiniMinusButton,EmptyBox,Checkbox,Time} from '../components/Input';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import {Spreadsheet,Photo,Attachment,Report} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';
import SignatureCanvas from 'react-signature-canvas'
import Measure from 'react-measure';
import "../styles/misconduct-list.scss";

export default class MisconductList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Disciplinary Matters",
        permission:"misconduct",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/misconduct-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-misconduct-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-misconduct-entries",
        spreadsheetURL:"/api/generate-misconduct-spreadsheet",
        overviewURL:"/api/get-all-misconduct-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"misconduct-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
        offenseOptions:[],
    };

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:[
                    "offenseStatus"
                ],
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const offensePermission = u.getPermissions("combined");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0);
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:permissions.create},
                {label:"Delete Entries",ref:"delete",enabled:permissions.delete},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled},
                {label:"Configure Offenses",ref:"configureOffenses",enabled:offensePermission.offense,
                    onClick:()=>{window.open("/offense-list","_blank")}
                },
            ],
            permissions:permissions,
        });
        this.getOptions();
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    onDeleteStep=(success)=>{
        this.r['layout'].onPopup({
          confirm:()=>{
              success();
              this.r['layout'].onCancelPopup();
          },
          title:"Confirm delete step?",
          description:"Note. This action cannot be undone",
        });
    }

    onSearchHistory=(nric,entryType)=>{
        this.settings.overview.onTagChange(
            [
                "@nric("+nric+")",
                "@entryType("+entryType+")",
                "@offenseAfter(01-01-"+moment().format('YYYY')+")",
                "@offenseBefore(31-12-"+moment().format('YYYY')+")",
            ],
            [
                {field:"offenseDateTime",direction:"descending"}
            ]
        )
    }

    render=()=>{
        const pageComponents={
            add:{component:AddMisconductEntry,props:{onSearchHistory:this.onSearchHistory}},
            delete:{component:DeleteListItem,props:{}},
            spreadsheet:{component:GenerateSpreadsheet,props:{}},
            bulkEdit:{component:BulkEdit,props:{}},
        };

        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={pageComponents}
                          selected={this.state.selected}
                          />


                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <MisconductItem key={index}
                                                index={index}
                                                content={content}
                                                onChange={onChange}
                                                onContentChange={onContentChange}
                                                registerReference={registerRef}
                                                options={this.state.options}
                                                settings={this.settings}
                                                permissions={this.state.permissions}
                                                onDeleteStep={this.onDeleteStep}
                                                />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

export class MiniMisconductList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Misconduct",
        permission:"resident",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/misconduct-list",
        spreadsheetURL:"/api/generate-misconduct-spreadsheet",
        overviewURL:"/api/get-all-misconduct-entries",

        /**** List Setup ****/
        listLabel:"misconduct-list",
        orderByField:"createdOn",
        orderByType:"descending",
        //detailsLink:"/absence-reason-list/", //Leave null if linking to list
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
            />
        )
    }
}

class MisconductItem extends React.Component{
    r={};

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
        removeIndex:0,
        photoIndex:0,
        offenseTypeOptions:[],
        yesNoOptions:[{value:0,label:"No"},{value:1,label:"Yes"}],
    };

    onRemoveRequest=(index)=>{
        this.setState({removeIndex:index,step:"remove",error:""});
    }

    onRemoveConfirm=()=>{
        this.setState({loading:false,loadText:"Removing offense..."});
        const content=this.props.content;
        u.post({
            url:"/api/misconduct-remove-offense",
            data:{
                misconductID:content.misconductID,
                offense:content.offenses[this.state.removeIndex]
            },
            success:()=>{
                const offenses=content.offenses;
                offenses.splice(this.state.removeIndex,1);
                this.setState({step:"view",loading:false,removeIndex:0});
                this.props.onChange(offenses,"offenses",this.props.index);
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onAddOffenseRequest=()=>{
        this.setState({loading:true,loadText:"Getting offenses..."});
        const {content}=this.props;
        u.post({
            url:"/api/get-offense-types",
            data:{
                dormID:content.dormID,
                entryType:content.entryType,
            },
            success:(offenseTypeOptions)=>{
                this.setState({
                  offenseTypeOptions:offenseTypeOptions,
                  loading:false,
                  error:"",
                  step:"add",
                });
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        })
    }

    onAddOffense=()=>{
        this.setState({loading:true,loadText:"Adding offense..."});
        const offenseID = this.r['offenseID'].validate();
        if(!offenseID.valid){
            this.setState({error:offenseID.value});
            return 0;
        }
        const content=this.props.content;
        u.post({
            url:"/api/misconduct-add-offense",
            data:{
                misconductID:content.misconductID,
                offenseID:offenseID.value,
            },
            success:(offenseEntry)=>{
                let offenses=content.offenses;
                offenses.push(offenseEntry);
                this.props.onChange(offenses,"offenses",this.props.index);
                this.setState({step:"view",loading:false,error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onChangeOffense=(value,label,index)=>{
        let offenses=this.props.content.offenses;
        offenses[index][label]=value;
        this.props.onChange(offenses,"offenses",this.props.index);
    }

    onViewPhoto=()=>{

    }

    onFileDrop=(filename,file,ext)=>{
        ext = ext.toLowerCase();
        this.userFilename = filename;
        this.isAttachment = (ext != "jpg" && ext != "jpeg" && ext !="png");
        this.setState({loading:true,loadText:"Uploading..."});
    }

    onAddPhoto=(url)=>{
        this.setState({loading:true,loadText:"Committing..."});
        if(this.isAttachment){
          u.post({
              url:"/api/misconduct-add-attachment",
              data:{
                  misconductID:this.props.content.misconductID,
                  filename:url
              },
              success:(attachment)=>{
                  let attachments=this.props.content.attachments;
                  attachments.unshift(attachment);
                  this.props.onChange(attachments,"attachments",this.props.index);
                  this.setState({step:"view",loading:false,error:""});
              },
              error:(error)=>{
                  this.setState({error:error,loading:false});
              }
          });
        }
        else{
          u.post({
              url:"/api/misconduct-add-photo",
              data:{
                  misconductID:this.props.content.misconductID,
                  filename:url
              },
              success:()=>{
                  let photos=this.props.content.photos;
                  photos.push({filename:this.userFilename,url:url});
                  this.props.onChange(photos,"photos",this.props.index);
                  this.setState({step:"view",loading:false,error:""});
              },
              error:(error)=>{
                  this.setState({error:error,loading:false});
              }
          });
        }

    }

    onRemovePhoto=()=>{
        this.setState({loading:true,loadText:"Removing photo..."});
        const content=this.props.content;
        u.post({
            url:"/api/misconduct-remove-photo",
            data:{
                misconductID:content.misconductID,
                photo:content.photos[this.state.photoIndex],
            },
            success:()=>{
                let photos=content.photos;
                photos.splice(this.state.photoIndex,1);
                this.props.onChange(photos,"photos",this.props.index);
                this.setState({step:"view",loading:false,error:"",photoIndex:0});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onIncidentReport=()=>{
        let acknowledgement=this.r['acknowledgement'].validate();
        let report = Object.assign({},this.props.content);
        report.acknowledgement=(acknowledgement.value==1);
        store.set("incident-report",report);
        window.open("/misconduct-incident-report","_blank");
    }

    onSendIncidentReport=()=>{
        this.setState({loading:true,loadText:"Sending report..."});
        u.post({
            url:"/api/misconduct-send-incident-report",
            data:{
                misconductID:this.props.content.misconductID,
            },
            success:()=>{
                this.setState({step:"sent",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onAddResolutionStep=()=>{
        if(this.state.adding){
            return 0;
        }
        this.setState({error:""});
        const newStep = this.r['resolution-step'].validate();
        if(!newStep.valid){
            this.setState({error:newStep.value});
            return 0;
        }
        this.setState({adding:true});
        const content=this.props.content;
        u.post({
            url:"/api/add-misconduct-resolution-step",
            data:{
                misconductID:content.misconductID,
                remark:newStep.value
            },
            success:(step)=>{
                let resolutionStack=content.resolutionStack;
                resolutionStack.unshift(step);
                this.props.onChange(resolutionStack,"resolutionStack",this.props.index);
                this.r['resolution-step'].clear();
                this.setState({adding:false});
            },
            error:(error)=>{
                this.setState({error:error,adding:false});
            }
        })
    }

    onDeleteStep=(index)=>{
        const itemIndex=this.props.index;
        const stepIndex=index;

        this.props.onDeleteStep(()=>{
            const content=this.props.content;
            u.post({
                  url:"/api/delete-misconduct-resolution-step",
                  data:{
                      misconductID:content.misconductID,
                      step:content.resolutionStack[stepIndex]
                  },
                  success:()=>{},
                  error:(error)=>{this.setState({error:error})}
              });
              let resolutionStack = content.resolutionStack;
              resolutionStack.splice(stepIndex,1);
              this.props.onChange(resolutionStack,"resolutionStack",itemIndex);
        });
    }

    onDeleteAttachmentRequest=(index)=>{
        this.setState({removeAttachment:index,step:"remove-attachment",error:""});
    }

    onDeleteAttachment=()=>{
        this.setState({loading:true,loadText:"Deleting Attachment..."});
        const content=this.props.content;
        u.post({
            url:"/api/misconduct-remove-attachment",
            data:{
                misconductID:content.misconductID,
                attachment:content.attachments[this.state.removeAttachment]
            },
            success:()=>{
                let content=this.props.content;
                content.attachments.splice(this.state.removeAttachment,1);
                this.props.onChange("attachments",content.attachments,this.props.index);
                this.setState({step:"view",error:"",loading:false});
            },
            error:(error)=>{
                this.setState({loading:false,error:error});
            }
        })
    }

    onDownloadAttachment=(filename,filestamp)=>{
       u.download(filename,filestamp);
    }

    mergeAttachments=(content)=>{
        let files=[];
        files = files.concat(content.photos.map(
            (item,index)=>{
                return {
                    type:"photo",
                    index:index,
                    filename:item.filename,
                    filestamp:item.url,
                    staffID:(item.staffID) ? item.staffID : "-",
                    staffName:(item.staffName) ? item.staffName : "-",
                    uploadOn:(item.uploadOn) ? item.uploadOn : "-"
                }
            }
        ));

        files = files.concat(content.attachments.map(
            (item,index)=>{
                item.type="attachment",
                item.index=index;
                return item;
            }
        ));

        return files;
    }

    render=()=>{
        const content = this.props.content;
        const permissions = this.props.permissions;
        const options = this.props.options;
        const infoPlaceholder = {width:"15px",height:"15px",marginBottom:"7px"};
        const demerits = content.offenses.filter(
                            (item)=>{return item.status == "Active"}
                          ).reduce((acc,curr)=>{return acc + parseInt(curr.demerits)},0);
        const canEdit = (permissions.update);
        const attachments = this.mergeAttachments(content);

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea content={this.props.content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     listLabel={this.props.settings.listLabel}
                                     permission={this.props.settings.permission}
                                     combinedField={this.props.settings.combinedField}
                                     />

                    <div className="list-table-container" style={{margin:"30px"}}>
                        <h3>Reported Offenses ({demerits} Demerits)</h3>
                        {
                            (content.offenses.length > 0)
                                ?
                                <div className="list-table" style={{maxHeight:"none"}}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="remove"/>
                                                <th>Offense/Observation</th>
                                                <th style={{width:"180px"}}>Action</th>
                                                <th style={{width:"100px",textAlign:"center"}}>Demerits</th>
                                                <th style={{width:"150px"}}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          {
                                              content.offenses.map(
                                                  (item,index)=>{
                                                      return(
                                                          <tr key={index} className="item">
                                                              <td className="remove">
                                                                  {(index+1)}.
                                                              </td>
                                                              <td style={{textDecoration:((item.status != "Active") ? "line-through" : undefined)}}>{item.label}</td>
                                                              <td style={{textDecoration:((item.status != "Active") ? "line-through" : undefined)}}>({item.occurrence}) {item.penalty}</td>
                                                              <td style={{textDecoration:((item.status != "Active") ? "line-through" : undefined),width:"100px",textAlign:"center"}}>{item.demerits}</td>
                                                              <td style={{width:"150px"}}>
                                                                  <EditableSelect values={{
                                                                                    value:item.status,
                                                                                    options:options.offenseStatus
                                                                                  }}
                                                                                  field="status"
                                                                                  id={{misconductID:content.misconductID,offense:item}}
                                                                                  url="/api/update-misconduct-info"
                                                                                  index={index}
                                                                                  label="Offense Status"
                                                                                  onChange={this.onChangeOffense}
                                                                                  />
                                                              </td>
                                                          </tr>
                                                      )
                                                  }
                                              )
                                          }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="list-placeholder">
                                    <h3>No Offenses</h3>
                                    <div>Click below to add offense</div>
                                </div>
                        }
                    </div>

                    <div className="list-image-container" style={{textAlign:"center"}}>
                        <h3>Photos & Attachments</h3>
                        {
                            (attachments.length > 0)
                              ?
                              <div className="list-table-container">
                                <div className="list-table" style={{maxHeight:"none"}}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="remove"/>
                                                <th>Attachment</th>
                                                <th className="attachment-short"/>
                                                <th className="attachment-short"/>
                                                <th className="attachment-download"/>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                attachments.map(
                                                    (item,index)=>{
                                                        return(
                                                            <tr key={index} className={((item.type=="photo") ? "photo-tr" : "") + " item"}>
                                                                <td className="remove">
                                                                    <div style={{position:"relative",width:"15px",height:"15px"}}>
                                                                        <MiniMinusButton onClick={()=>{this.onDeleteAttachmentRequest(index)}}
                                                                                         enabled={canEdit}
                                                                                         />
                                                                    </div>
                                                                </td>
                                                                <td>{item.filename}</td>
                                                                <td className="attachment-short">{item.staffName}</td>
                                                                <td className="attachment-short">{(item.uploadOn=="-") ? "-" : moment(item.uploadOn).format("DD MMM YY hh:mma")}</td>
                                                                <td className="attachment-download">
                                                                    {
                                                                        (item.type == "photo")
                                                                            ?
                                                                            <img src={item.filestamp}
                                                                                 className="attachment-image"
                                                                                 resizeMode="contain"
                                                                                 onClick={()=>{this.setState({step:"view-photo",photoIndex:index,error:""})}}
                                                                                 />
                                                                            :
                                                                            <img className="misconduct-download"
                                                                                 src="/images/input/down-arrow.png"
                                                                                 onClick={()=>{this.onDownloadAttachment(item.filename,item.filestamp)}}
                                                                                 />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                              </div>
                              :
                              <div className="list-placeholder">
                                <h3>No Photos & Attachments</h3>
                                <div>Click below to add new photo or attachment</div>
                              </div>
                        }
                    </div>

                    <div style={{margin:"20px auto",textAlign:"center"}}>
                        {
                            (canEdit)
                                ?
                                <TextButton onClick={()=>{this.setState({step:"add-photo",error:""})}}>Add Photo/Attachment</TextButton>
                                :
                                null
                        }
                        <TextButton onClick={()=>{this.setState({step:"resolution",error:""})}}>Resolution Steps</TextButton>
                    </div>

                    <div style={{margin:"20px auto",textAlign:"center"}}>
                        <Button onClick={()=>{this.setState({step:"view-report",error:""})}}>View Report</Button>
                        <Button onClick={()=>{this.setState({step:"send-report",error:""})}}>Send Report</Button>
                    </div>

                    <div style={{margin:"20px auto",textAlign:"center"}}>
                        <ResolutionStack content={content.participants}/>
                    </div>
                </Step>

                <Step active={this.state.step=="add"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <h3>Add Offense</h3>

                        <div className="segment-full-item" style={{margin:"20px auto"}}>
                            <div className="segment-item-label">Offense:</div>
                            <div className="segment-item-input">
                                <Select ref={(ref)=>{this.r["offenseID"]=ref}}
                                        values={{options:this.state.offenseTypeOptions}}
                                        label="Offense"
                                        rules={{required:true}}
                                        />
                            </div>
                        </div>

                        <div className="segment-buttons">
                            <div className="page-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onAddOffense}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="remove"} scroll={true}>
                    {
                        (content.offenses[this.state.removeIndex])
                            ?
                            <div style={{fontSize:"14px",textAlign:"center"}}>
                                <h3 className="text-negative">Remove Offense - {content.offenses[this.state.removeIndex].label}</h3>
                                <div className="list-segment-note">Note. This action cannot be undone</div>
                                <div className="segment-buttons">
                                    <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                                    <Button onClick={this.onRemoveConfirm}>Confirm</Button>
                                </div>
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={this.state.step=="remove-attachment"} scroll={true}>
                    {
                        (content.attachments[this.state.removeAttachment])
                            ?
                            <div style={{fontSize:"14px",textAlign:"center"}}>
                                <h3 className="text-negative">Remove Attachment - {content.attachments[this.state.removeAttachment].filename}</h3>
                                <div className="list-segment-note">Note. This action cannot be undone</div>
                                <div className="segment-buttons">
                                    <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                                    <Button onClick={this.onDeleteAttachment}>Confirm</Button>
                                </div>
                            </div>
                            :
                            null
                    }
                </Step>

                <Step active={this.state.step=="view-photo"} scroll={true}>
                    <div style={{padding:"20px 0",position:"relative",textAlign:"center"}}>
                        <div className="list-image-container">
                            {
                                content.photos.map((item,index)=>{
                                    return(
                                        <img key={index} src={item.url} className="list-image-item" onClick={()=>{this.setState({photoIndex:index,error:""})}}/>
                                    )
                                })
                            }
                        </div>

                        <div>
                            {
                                (content.photos.length > this.state.photoIndex)
                                    ?
                                    <img src={content.photos[this.state.photoIndex].url} className="list-view-image" onClick={()=>{window.open(content.photos[this.state.photoIndex].url,"_blank")}}/>
                                    :
                                    null
                            }
                        </div>

                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={()=>{this.setState({step:"remove-photo",error:""})}}>Delete Photo</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="add-photo"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={this.onFileDrop}
                                  onUploaded={this.onAddPhoto}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Attachment}
                                  />

                        <div style={{margin:"20px auto"}}>Photos will be included into the misconduct report, whereas attachments (non-photos) will be attached when you Send Report</div>

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="attachment"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <h3>Add Attachments</h3>
                        <div>Note. Attachments will not appear in the misconduct report, Attachments will be attached to the email when you use the send report function</div>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Attachment}
                                  />

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="remove-photo"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        {
                            (content.photos.length > this.state.photoIndex)
                                ?
                                <h3 className="text-negative">Remove Photo - {content.photos[this.state.photoIndex].filename}?</h3>
                                :
                                null
                        }
                        <div className="list-segment-note">Note. This action cannot be undone</div>
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view-photo",error:""})}}>Back</Button>
                            <Button onClick={this.onRemovePhoto}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="send-report"} scroll={true}>
                    <div style={{padding:"30px 0",textAlign:"center",fontSize:"14px"}}>
                        <h3>Send Incident Report To Client?</h3>
                        <div className="list-segment-note">Report will be sent to all client contact email marked as <b>Operations</b> in the address book</div>
                        <div className="list-segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view"})}}>Back</Button>
                            <Button onClick={this.onSendIncidentReport}>Send</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="sent"} scroll={true}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <SegmentComplete onComplete={()=>{this.setState({step:"view",error:""})}}>
                            <h2>Incident Report Sent Successfully</h2>
                        </SegmentComplete>
                    </div>
                </Step>

                <Step active={this.state.step=="view-report"} scroll={true}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <h2>Show Incident Report With Acknowledgment?</h2>
                        <div style={{margin:"20px auto",width:"400px",maxWidth:"96%"}}>
                            <Select ref={(ref)=>{this.r["acknowledgement"]=ref}}
                                    values={{options:this.state.yesNoOptions}}
                                    label="Acknowledgement"
                                    />
                        </div>
                        <div className="list-segment-buttons">
                            <div className="list-segment-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onIncidentReport}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step == "resolution"} style={{textAlign:"center"}} scroll={true}>
                    <h2>Resolution Steps</h2>

                    {
                        (content.resolutionStack.length > 0)
                            ?
                            <div className="resolution-step-container">
                                {
                                    content.resolutionStack.map(
                                        (item,index)=>{
                                            return (
                                                <ResolutionStep key={index}
                                                                content={item}
                                                                index={index}
                                                                onDelete={this.onDeleteStep}
                                                                />
                                            )
                                        }
                                    )
                                }
                            </div>
                            :
                            <div className="list-segment-placeholder" style={{padding:"50px 0",width:"600px"}}>
                                No Steps Documented
                            </div>
                    }

                    <div className="segment-full-item" style={{fontSize:"12px"}}>
                        <Area rules={{
                                required:true,
                                rows:5,
                                placeholder:"Enter a new resolution step"
                              }}
                              ref={(ref)=>{this.r["resolution-step"]=ref}}
                              label="Resolution Step"
                              />
                    </div>

                    <div className="list-segment-buttons">
                        <div className="list-segment-error">{this.state.error}</div>
                        <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        <Button onClick={this.onAddResolutionStep}>Add Step</Button>
                    </div>
                </Step>

            </div>
        )
    }
}

class AddMisconductEntry extends React.Component{
    r={};

    state={
        additional:{},
        dormOptions:[],
        offenseTypeOptions:[],
        entryData:{
            offenses:[],
            photos:[],
            attachments:[],
            offenseDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
            nextReviewDate:moment().format("YYYY-MM-DD"),
            filterType:"All",
            filterCategory:"All",
        },
        options:{

        },
        tenantInfo:{},
        step:"resident",
        loading:false,
        loadText:"",
        dimensions:{
          width:500,
          height:200,
        },
    };

    show=(show)=>{
        this.r[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        this.getDormOptions();
        this.getOptions();
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["offenseFilterType","offenseFilterCategory"]
            },
            success:(options)=>{
                for(var key in options){
                    options[key].unshift({value:"All",label:"All"});
                }
                options['misconductEntryType']=[
                    {value:"Resident",label:"Resident"},
                    {value:"Staff",label:"Staff"}
                ]
                this.setState({options:options});
            }
        })
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
              type:"dorm"
            },
            success:(dormOptions)=>{
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getOffenses=async (entryData)=>{
        const offenseTypeOptions = await u.postAsync({
            url:"/api/get-offense-types",
            data:{
                entryType:entryData.entryType,
                dormID:entryData.dormID,
                filterType:entryData.filterType,
                filterCategory:entryData.filterCategory,
            }
        });

        this.setState({offenseTypeOptions:offenseTypeOptions.data});
    }

    onCancel=()=>{
        this.setState({
          step:"resident",
          error:"",
          entryData:{
            offenses:[],
            photos:[],
            attachments:[],
            filterType:"All",
            filterCategory:"All"
          }
      });
        this.props.onToggleForm(this.props.reference,false);
    }

    onResident=async ()=>{
        const keys=['entryType','identifier'];
        let data={};
        for(var i=0; i<keys.length; i++){
            const current=this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }
        this.setState({loading:true,loadText:"Finding Offender..."});
        this.entryType=data.entryType;

        try{
            const tenantInfo = await u.postAsync({
                url:"/api/search-for-offender",
                data:{
                    entryType:data.entryType,
                    searchParam:data.identifier,
                }
            });
            const {entryData}=this.state;

            entryData.dormID = tenantInfo.data.dormID;

            this.props.onSearchHistory(tenantInfo.data.offenderNRIC,entryData.entryType);

            await this.getOffenses(entryData);

            this.setState({
                loading:false,
                tenantInfo:tenantInfo.data,
                entryData:entryData,
                step:"details",
                error:""
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }

    }

    onAddPhoto=(url)=>{
        let entryData=this.state.entryData;
        entryData.photos.push({filename:this.userFilename,url:url});
        this.setState({entryData:entryData,step:"details",error:"",loading:false});
    }

    onRemovePhoto=(index)=>{
       let entryData=this.state.entryData;
       entryData.photos.splice(index,1);
       this.setState({entryData:entryData});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        entryData.attachments.push({filename:this.userFilename,url:url});
        this.setState({entryData:entryData,step:"details",error:"",loading:false});
    }

    onRemoveAttachment=(index)=>{
       let entryData=this.state.entryData;
       entryData.attachments.splice(index,1);
       this.setState({entryData:entryData});
    }

    onAddOffenseRequest=()=>{
        let {entryData}=this.state;
        entryData.filterType="All";
        entryData.filterCategory="All";
        this.setState({
            step:"add-offense",
            error:"",
            entryData:entryData
        })
    }

    onAddOffense=()=>{
        const offense=this.r['offense'].validate();
        if(!offense.valid){
            this.setState({error:offense.value});
            return 0;
        }
        let {entryData}=this.state;
        entryData.offenses.push(offense.option);
        this.setState({entryData:entryData,step:"details",error:"",loading:false});
    }

    onRemoveOffense=(index)=>{
        let {entryData}=this.state;
        entryData.offenses.splice(index,1);
        this.setState({entryData:entryData,error:""});
    }

    onChangeNewOffense=(value,label)=>{
        let {newOffense}=this.state;
        newOffense[label]=value;
        this.setState({newOffense:newOffense});
    }

    onValidate=()=>{
        this.setState({error:""});
        const keys=["offenses","offenseDate","offenseDateTime","photos","remarks","attachments","nextReviewDate"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current = this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }

        const needSignature = this.r['signature'].validate();
        if(needSignature.value){
            this.data=data;
            this.setState({step:"sign",error:""});
        }
        else{
            this.r[this.props.reference].onValidated({
                entryType:this.entryType,
                ...data,
                ...this.state.tenantInfo
            });
        }
    }

    onChange=(value,field,index,option)=>{
        let entryData = this.state.entryData;
        entryData[field] = value;
        this.setState({entryData:entryData});
    }

    onComplete=()=>{
        this.setState({
          step:"resident",
          error:"",
          loading:false,
          entryData:{
            offenses:[],
            photos:[],
            attachments:[],
            offenseDateTime:moment().format("YYYY-MM-DD HH:mm:ss"),
            nextReviewDate:moment().format("YYYY-MM-DD"),
          }
        });
    }

    onConfirmSignature=()=>{
        this.setState({error:""})
        if(this.sigCanvas.isEmpty()){
            this.setState({error:"Please sign in the box above to continue"});
            return 0;
        }

        this.setState({loading:true,loadText:"Uploading Signature..."});

        const signatureURL = this.sigCanvas.getTrimmedCanvas().toDataURL("image/png");

        var arr = signatureURL.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

      const signature = new File([u8arr], "misconduct-signature", {type:mime});
      u.upload({
          file:signature,
          filename:"misconduct-signature.png",
          success:(signature)=>{
              this.data.signature=signature;
              this.r[this.props.reference].onValidated({
                entryType:this.entryType,
                ...this.data,
                ...this.state.tenantInfo
            });
          },
          error:(error)=>{
              this.setState({error:error,loading:false})
          }
      });
    }

    onChangeOffenseParam=(value,label)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
        this.getOffenses(entryData);
    }

    render=()=>{
        const infoInput={width:"15px",height:"15px",marginBottom:"3px"};
        const infoPlaceholder={width:"15px",height:"15px",marginBottom:"9px"};
        const {dimensions,entryData,options,tenantInfo} = this.state;

        return(
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         filetypes={Spreadsheet}
                         additional={this.state.additional}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}
                         >

                <div className="segment-content" style={{position:"relative",textAlign:"center"}}>
                    <div className="segment-error">{this.state.error}</div>
                    <LoadGraphic active={this.state.loading} text={this.state.loadText}/>

                    <Step active={this.state.step=="resident"}>
                        <div>
                            <h3>Enter NRIC or FIN to find offender</h3>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Entry Type</div>
                                <div className="segment-item-input">
                                    <Select ref={(ref)=>{this.r["entryType"]=ref}}
                                            values={{values:entryData.entryType,options:options.misconductEntryType}}
                                            label="Entry Type"
                                            field="entryType"
                                            onChange={this.onChange}
                                            />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">NRIC/FIN:</div>
                                <div className="segment-item-input">
                                    <Box ref={(ref)=>{this.r["identifier"]=ref}}
                                         label="Identifier"
                                         rules={{required:true}}
                                         />
                                </div>
                            </div>
                            <div className="segment-buttons">
                                {
                                    (u.isMobileDevice())
                                        ?
                                        <Button onClick={this.onCancel}>Cancel</Button>
                                        :
                                        null
                                }
                                <Button onClick={this.onResident}>Create</Button>
                            </div>
                        </div>
                    </Step>

                    <Step active={this.state.step=="details"}>
                        <div>
                            <h3>Complete the following to create entry</h3>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Offender:</div>
                                <div className="segment-item-input text-emphasis">
                                    <Box label="Offender Name"
                                         values={{value:tenantInfo.offenderName,enabled:false}}
                                         />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Offender FIN:</div>
                                <div className="segment-item-input text-emphasis">
                                    <Box label="Offender Name"
                                         values={{value:tenantInfo.offenderNRIC,enabled:false}}
                                         />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Performance Banding:</div>
                                <div className="segment-item-input text-emphasis">
                                    <Box label="Offender Name"
                                         values={{value:tenantInfo.safetyPoints,enabled:false}}
                                         />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Offense Date:</div>
                                <div className="segment-item-input text-emphasis">
                                    <Date ref={(ref)=>{this.r["offenseDate"]=ref}}
                                          label="Offense Date"
                                          field="offenseDateTime"
                                          values={{value:entryData.offenseDateTime}}
                                          range={[3,2]}
                                          onChange={this.onChange}
                                          />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Offense Time:</div>
                                <div className="segment-item-input text-emphasis">
                                    <Time ref={(ref)=>{this.r["offenseDateTime"]=ref}}
                                          label="Offense Time"
                                          field="offenseDateTime"
                                          values={{value:entryData.offenseDateTime}}
                                          onChange={this.onChange}
                                          />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Offenses/Observation:</div>
                                <div className="segment-item-input">
                                    <List ref={(ref)=>{this.r["offenses"]=ref}}
                                          label="Offenses"
                                          field="offenses"
                                          values={{value:entryData.offenses}}
                                          rules={{required:true}}
                                          nullText="Click to add offense"
                                          onChange={this.onChange}
                                          onAdd={this.onAddOffenseRequest}
                                          onRemove={this.onRemoveOffense}
                                          hideAdd={true}
                                          />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Photos:</div>
                                <div className="segment-item-input">
                                    <InputPhoto ref={(ref)=>{this.r["photos"]=ref}}
                                                label="Photos"
                                                field="photos"
                                                values={{value:entryData.photos}}
                                                onAdd={()=>{this.setState({step:"add-photo",error:""})}}
                                                onRemove={this.onRemovePhoto}
                                                onChange={this.onChange}
                                                />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Attachments:</div>
                                <div className="segment-item-input">
                                    <InputPhoto ref={(ref)=>{this.r["attachments"]=ref}}
                                                label="Attachments"
                                                field="attachments"
                                                type="attachment"
                                                values={{value:entryData.attachments}}
                                                onAdd={()=>{this.setState({step:"add-attachment",error:""})}}
                                                onRemove={this.onRemoveAttachment}
                                                onChange={this.onChange}
                                                rules={{nullText:"Click to add attachment"}}
                                                />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Remarks:</div>
                                <div className="segment-item-input">
                                    <Area ref={(ref)=>{this.r["remarks"]=ref}}
                                          label="Remarks"
                                          field="remarks"
                                          values={{value:entryData.remarks}}
                                          onChange={this.onChange}
                                          />
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Next Review Date:</div>
                                <div className="segment-item-input">
                                    <Date ref={(ref)=>{this.r["nextReviewDate"]=ref}}
                                          label="Next Review Date"
                                          field="nextReviewDate"
                                          values={{value:entryData.nextReviewDate}}
                                          range={[3,2]}
                                          onChange={this.onChange}
                                          />
                                </div>
                            </div>

                            <div className='segment-full-item' style={{margin:"20px auto"}}>
                                <Checkbox ref={(ref)=>{this.r["signature"]=ref}}
                                          values={{value:entryData.requireSignature}}
                                          field="requireSignature"
                                          onChange={this.onChange}
                                          label="Resident Signature"/> Require Resident Signature
                            </div>

                            <div className="segment-buttons">
                                <div className="segment-error">{this.state.error}</div>
                                <Button onClick={()=>{this.setState({step:"resident",error:""})}}>Back</Button>
                                <Button onClick={this.onValidate}>Confirm</Button>
                            </div>
                        </div>
                    </Step>

                    <Step active={this.state.step=="add-photo"}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddPhoto}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />
                        <div style={{fontSize:"0.85em",margin:"20px auto"}}>Photos are included directly into the misconduct report</div>
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"details",error:""})}}>Back</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step=="add-attachment"}>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Report}
                                  />
                        <div style={{fontSize:"0.85em",margin:"20px auto"}}>Attachments are documents that are attached when you Send Report</div>
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"details",error:""})}}>Back</Button>
                        </div>
                    </Step>

                    <Step active={this.state.step=="add-offense"}>
                        <div>
                            <h3>Add Offense/Observation</h3>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Filter Type:</div>
                                <div className="segment-item-input">
                                    <Select ref={(ref)=>{this.r["filterType"]=ref}}
                                            label="Filter Type"
                                            field="filterType"
                                            values={{value:entryData.filterType,options:options.offenseFilterType}}
                                            rules={{required:true}}
                                            onChange={this.onChangeOffenseParam}
                                    />
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Filter Category:</div>
                                <div className="segment-item-input">
                                    <Select ref={(ref)=>{this.r["filterCategory"]=ref}}
                                            label="Filter Category"
                                            field="filterCategory"
                                            values={{value:entryData.filterCategory,options:options.offenseFilterCategory}}
                                            rules={{required:true}}
                                            onChange={this.onChangeOffenseParam}
                                    />
                                </div>
                            </div>
                            <div className="segment-full-item">
                                <div className="segment-item-label">Offense:</div>
                                <div className="segment-item-input">
                                    <Select ref={(ref)=>{this.r["offense"]=ref}}
                                            label="Offense"
                                            values={{options:this.state.offenseTypeOptions}}
                                            rules={{required:true}}
                                            />
                                </div>
                            </div>
                            <div className="segment-buttons">
                                <Button onClick={()=>{this.setState({step:"details",error:""})}}>Back</Button>
                                <Button onClick={this.onAddOffense}>Confirm</Button>
                            </div>
                        </div>
                    </Step>

                    <Step active={this.state.step=="sign"}>
                        <h3>Sign below to acknowledge</h3>

                        <div className="segment-full-item">
                            <div className="segment-item-label">Offender:</div>
                            <div className="segment-item-input text-emphasis">
                                <EmptyBox style={{padding:"5px"}}>{this.state.tenantInfo.offenderName}</EmptyBox>
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Offender FIN:</div>
                            <div className="segment-item-input text-emphasis">
                                <EmptyBox style={{padding:"5px"}}>{this.state.tenantInfo.offenderNRIC}</EmptyBox>
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Offenses:</div>
                            <div className="segment-item-input text-emphasis">
                                <EmptyBox style={{padding:"5px"}}>
                                    <ol style={{padding:"0 0 0 20px",margin:"0"}}>
                                        {
                                            entryData.offenses.map((item,index)=>{
                                                return (
                                                    <li key={index} style={{marginTop:((index==0) ? "0" : "5px")}}>{item.label}</li>
                                                )
                                            })
                                        }
                                    </ol>
                                </EmptyBox>
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <b>General Photos</b>
                            <div>
                                {
                                    (entryData.photos.length > 0)
                                        ?
                                        entryData.photos.map(
                                            (photo,index)=>{
                                                return (
                                                    <img style={{width:"100px",margin:"5px 10px",borderRadius:"10px"}} src={photo.url} key={index}/>
                                                )
                                            }
                                        )
                                        :
                                        <div className="list-placeholder" style={{width:"500px",maxWidth:"80%"}}>
                                            <b>No Photos Added</b>
                                        </div>
                                }
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div><b>Offender Signature</b></div>

                            <Measure bounds onResize={contentRect => {this.setState({dimensions: contentRect.bounds})}}>
                            {
                                ({measureRef})=>
                                    (
                                        <div ref={measureRef} className="sigCanvas">
                                            <SignatureCanvas ref={(ref)=>{this.sigCanvas=ref}}
                                                             penColor='blue'
                                                             canvasProps={{
                                                               width: dimensions.width,
                                                               height: 200,
                                                               willreadfrequently:"true",
                                                             }}
                                                             />
                                        </div>
                                      )
                            }
                            </Measure>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className="page-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"details",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmSignature}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}
